// extracted by mini-css-extract-plugin
var _1 = "UserListItemContent-moduleblocked__nXzyQ";
var _2 = "UserListItemContent-modulehover__KAM7t";
var _3 = "UserListItemContent-moduleinfo__AUpAg";
var _4 = "UserListItemContent-moduletext__WQTyu";
export { _1 as "blocked", _2 as "hover", _3 as "info", _4 as "text" }
